export const DISPLAY_GO_HOME = 'DISPLAY_GO_HOME'; 


// WEBPACK FOOTER //
// ./src/features/registration/accountCreated/constants.js